import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import ShopInGroupTableHeadGroup from '../../components/molecules/ShopInGroupTableHeadGroup';
import ShopInGroupTableBodyGroup from '../../components/molecules/ShopInGroupTableBodyGroup';
import { sendLogin } from '../../auth/Auth';

const styles = {
  scrollTable: {
    maxHeight: '380',
    overflowX: 'scroll',
    border: '1px solid #CCCCCC',
    whiteSpace: 'nowrap'
  },
  stickyActionsColumn: {
    '& table': {
      backgroundColor: '#ffffff'
    },
    '& table th': {
      borderBottom: '2px solid #CCCCCC',
      zIndex: '10 !important',
      borderTop: '1px solid #CCCCCC',
      color: '#000000',
      fontWeight: 'bold',
      backgroundColor: '#ffffff'
    }
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(),
  setPropTypes(propTypes),
  withState('order', 'setOrder', 'asc'),
  withState('orderBy', 'setOrderBy', null),
  // withState('page', 'setPage', 0),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRequestSort: props => property => {
      const isDesc = props.orderBy === property && props.order === 'desc';
      props.setOrder(isDesc ? 'asc' : 'desc');
      props.setOrderBy(property);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    page,
    shopGroup,
    rowsPerPage,
    order,
    orderBy,
    handleRequestSort,
    roles,
    isFullInfo,
    isFukuoka
  }) => {
    return (
      <div>
        <div
          className={`${classes.scrollTable} ${classes.stickyActionsColumn}`}
          id="scrollTableId"
        >
          <Table stickyHeader>
            <ShopInGroupTableHeadGroup
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              roles={roles}
              isFullInfo={isFullInfo}
              isFukuoka={isFukuoka}
            />
            <ShopInGroupTableBodyGroup
              shopGroup={shopGroup.list}
              page={page}
              rowsPerPage={rowsPerPage}
              order={order}
              orderBy={orderBy}
              isFullInfo={isFullInfo}
              isFukuoka={isFukuoka}
            />
          </Table>
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
